<nav class="navbar navbarcustom">
  <div class="container-fluid d-flex justify-content-between align-items-center nav-xsp0">
    <a class="navbar-brand d-flex align-items-center">
      <span class="custom-logo">
        <img src="/assets/images/TMCV-New-Logo.png" alt="Tata Motors Commercial Vehicles" height="42"
          class="d-inline-block">&nbsp;
        </span>&nbsp;
        <span class="navbar-text ms-2">FleetCare</span>
      </a>
      <img src="/assets/images/tata_Logo.png" alt="Tata Logo" class="d-inline-block end-image d-none d-sm-block">
    </div>
  </nav>

  <div class="login-container">
    <div class="background-image">
      <img src="/assets/images/dealer_login.png" alt="Background" />
    </div>

    <div class="login-box" [ngClass]="{'login-box-wide': currentStep === 'register-mfa'}">

      <!-- ══════════════════════════════════════
      STEP 1 — LOGIN FORM
      ══════════════════════════════════════ -->
    @if (currentStep === 'login') {
      <h1>Login</h1>
      <form #loginForm="ngForm">
        <!-- Username -->
        <div class="form-group mt-2">
          <label for="username" class="required">Username</label>
          <input type="text" class="form-control" id="username" name="username" placeholder="Enter Username"
            [(ngModel)]="username" #usernameField="ngModel" required
            (input)="sanitizeUsername($event)" autocomplete="username" />
          @if (usernameField.invalid &&
            (usernameField.dirty || usernameField.touched || loginForm.submitted)) {
            <div class="check-message">Username is
              required.
            </div>
          }
        </div>
        <!-- Password -->
        <div class="form-group position-relative mt-2">
          <label for="password">Password *</label>
          <input [type]="showPassword ? 'text' : 'password'" name="password" class="form-control password-icon"
            id="password" placeholder="Enter Password" [(ngModel)]="password" #passwordField="ngModel" required
            autocomplete="current-password" />
          <span class="input-group-text cursor-pointer password-icon2">
            <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
            (click)="showPassword = !showPassword"></i>
          </span>
          @if (passwordField.invalid && (passwordField.dirty || passwordField.touched || loginForm.submitted)) {
            <div
              class="check-message">
              Password is required.
            </div>
          }
        </div>
        <!-- CAPTCHA -->
        <div class="form-group mt-2">
          <label>Captcha *</label>
          <div class="d-flex align-items-center gap-2">
            <span class="captcha-box">{{ captchaText }}</span>
            <input type="text" class="form-control" placeholder="Enter captcha" maxlength="6" [(ngModel)]="captchaInput"
              name="captchaInput" required (input)="hideCaptchaError()" style="max-width: 140px;" autocomplete="off" />
            <span class="captcha-refresh" (click)="generateCaptcha(); hideCaptchaError()" title="Refresh">
              <i class="pi pi-refresh"></i>
            </span>
          </div>
          <small class="captcha-hint">
            <i class="pi pi-info-circle me-1"></i>Captcha is case-sensitive. Type it exactly as shown.
          </small>
          @if (captchaError) {
            <div class="check-message">
              Incorrect CAPTCHA. Please try again.
            </div>
          }
        </div>
        <div class="btn-area">
          <button type="submit" class="login-button" [disabled]="!loginForm.form.valid || isLoading" (click)="login()">
            @if (isLoading) {
              <span class="spinner-border spinner-border-sm me-1"></span>
            }
            {{ isLoading ? 'Please wait...' : 'Login' }}
          </button>
        </div>
        <div class="help-link-wrap">
          <a href="javascript:void(0)" class="help-link" (click)="openHelpModal('first')">
            <i class="pi pi-question-circle me-1"></i> Need help to login?
          </a>
        </div>
      </form>
    }


    <!-- ══════════════════════════════════════
    STEP 2a — SETUP MFA (QR CODE)
    ══════════════════════════════════════ -->

    @if (currentStep === 'register-mfa') {
      <h1>Setup Two-Factor Authentication</h1>
      <!-- Step 1 -->
      <div class="mfa-step mt-3">
        <span class="step-badge">1</span>
        <p>
          Install an authenticator app on your smartphone or mobile device.
          We recommend <strong>Microsoft Authenticator</strong> or
          <strong>Google Authenticator</strong>. Once installed, you can
          complete your Two-Factor Authentication.
        </p>
      </div>
      <!-- Step 2 — QR -->
      <div class="mfa-step mt-3">
        <span class="step-badge">2</span>
        <div class="qr-section">
          <div class="qr-wrapper">
            <img [src]="qrCodeUrl" alt="QR Code" class="qr-image" />
          </div>
          <div class="qr-manual">
            <span class="or-divider">OR</span>
            <p class="manual-label">
              Enter code manually.
              <a href="javascript:void(0)" class="toggle-secret" (click)="toggleSecretKey()">
                {{ showSecretKey ? 'Hide code' : 'Show code' }}
              </a>
            </p>
            @if (showSecretKey) {
              <div class="secret-key-box">
                <span class="secret-text">{{ secretKey }}</span>
                <i class="pi pi-copy ms-2 copy-icon" (click)="copySecret()" title="Copy"></i>
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Step 3 — Enter code -->
      <div class="mfa-step mt-3">
        <span class="step-badge">3</span>
        <p>Enter the code you see on your authenticator app:</p>
      </div>
      <div class="form-group mt-2">
        <input type="text" id="totpInput" #totpInputRef class="form-control" placeholder="Enter 6-digit code"
          [(ngModel)]="totpSingleCode" [ngModelOptions]="{standalone: true}" name="totpSingleCode" maxlength="6" inputmode="numeric"
          (keydown.enter)="onTotpEnter($event)"
          (input)="sanitizeTotpCode($event)" autocomplete="one-time-code" />
      </div>
      @if (mfaError) {
        <div class="check-message mt-1">{{ mfaError }}</div>
      }
      <div class="btn-area mt-3">
        <button class="login-button" [disabled]="isLoading || totpSingleCode.length !== 6" (click)="submitTotp()">
          @if (isLoading) {
            <span class="spinner-border spinner-border-sm me-1"></span>
          }
          {{ isLoading ? 'Verifying...' : 'Verify' }}
        </button>
      </div>
      <div class="help-link-wrap">
        <a href="javascript:void(0)" class="help-link" (click)="openHelpModal('first')">
          <i class="pi pi-question-circle me-1"></i> Need help setting up?
        </a>
      </div>
      <div class="back-link mt-2">
        <a href="javascript:void(0)" (click)="goBackToLogin()">
          <i class="pi pi-arrow-left me-1"></i> Back to Login
        </a>
      </div>
    }


    <!-- ══════════════════════════════════════
    STEP 2b — ENTER TOTP (already set up)
    ══════════════════════════════════════ -->
    @if (currentStep === 'enter-totp') {
      <div class="mfa-icon-wrap">
        <i class="pi pi-shield mfa-shield-icon"></i>
      </div>
      <h1 class="text-center">Two-Factor Authentication</h1>
      <p class="mfa-subtitle text-center">
        Enter the 6-digit code from your authenticator app.
      </p>
      <div class="form-group mt-3">
        <label for="totpInput">6-digit code *</label>
        <input type="text" id="totpInput" #totpInputRef class="form-control" placeholder="Enter 6-digit code"
          [(ngModel)]="totpSingleCode" [ngModelOptions]="{standalone: true}" name="totpSingleCode" maxlength="6" inputmode="numeric"
          (keydown.enter)="onTotpEnter($event)"
          (input)="sanitizeTotpCode($event)" autocomplete="one-time-code" />
      </div>
      @if (mfaError) {
        <div class="check-message mt-1">{{ mfaError }}</div>
      }
      <div class="btn-area mt-3">
        <button class="login-button" [disabled]="isLoading || totpSingleCode.length !== 6" (click)="submitTotp()">
          @if (isLoading) {
            <span class="spinner-border spinner-border-sm me-1"></span>
          }
          {{ isLoading ? 'Verifying...' : 'Verify Code' }}
        </button>
      </div>
      <!-- Register new device link -->
      @if (isLocal) {
        <div class="register-device-link mt-2 text-center">
          <a href="javascript:void(0)" (click)="openRegisterDeviceModal()">
            <i class="pi pi-mobile me-1"></i> Register a New Device
          </a>
        </div>
      }
      <div class="help-link-wrap">
        <a href="javascript:void(0)" class="help-link" (click)="openHelpModal('returning')">
          <i class="pi pi-question-circle me-1"></i> Need help with the code?
        </a>
      </div>
      <div class="back-link mt-2">
        <a href="javascript:void(0)" (click)="goBackToLogin()">
          <i class="pi pi-arrow-left me-1"></i> Back to Login
        </a>
      </div>
    }

  </div><!-- /login-box -->

  <footer class="d-none">
    <div class="container">
      <div class="row" style="justify-content: center;">
        <div class="col-12 col-md-2 p-0" style="text-align: center;">
          <p><img src="../../../../assets/images/new-table/call.png">
          &#128222; 1800 209 7979</p>
        </div>
        <div class="col-12 col-md-4 contacttxt">
          <div class="footer-contact">
            <div><img src="../../../../assets/images/new-table/addresswhite.png"></div>
            <div class="txt">
              Tata Motors Commercial Vehicles Regional Office, Eastern Express Highway,
              Gyan Sadhna College Service Road, Teen Hath Naka, Thane, Maharashtra - 400615
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

</div>


<!-- ══════════════════════════════════════
MODAL — Force Login
══════════════════════════════════════ -->
<ng-template #forceLoginPopup let-modal>
  <div class="upload_container">
    <div class="modal-body">
      <p class="delete-title">Are you sure you want to force login?</p>
      <p class="text-muted small mb-0">
        This will terminate your existing session on other devices.
      </p>
    </div>
    <div class="modal-footer" style="display:flex; justify-content:space-between; padding:0;">
      <div class="form-group col-md-5 d-flex align-items-end">
        <button class="btn btn-t01 btn-white p-2 me-n1 w-100" (click)="modal.dismiss('Cross click')">Cancel</button>
      </div>
      <div class="form-group col-md-5 d-flex align-items-end">
        <button class="btn-t01 btn-navy p-2 me-n1 w-100" (click)="modal.close('Force Login')">Force Login</button>
      </div>
    </div>
  </div>
</ng-template>


<!-- ══════════════════════════════════════
MODAL — Register New Device
══════════════════════════════════════ -->
<ng-template #registerDevicePopup let-modal>
  <div class="upload_container">
    <div class="modal-body">
      <div class="text-center mb-2">
        <i class="pi pi-mobile" style="font-size: 2rem; color: var(--primary-color, #003d85);"></i>
      </div>
      <p class="delete-title">Register a New Device?</p>
      <p class="text small mb-0">
        A new QR code will be generated. Scan it with your authenticator app
        on the new device. Your old device will no longer work for 2FA after
        you complete the setup.
      </p>
    </div>
    <div class="modal-footer" style="display:flex; justify-content:space-between; padding:0;">
      <div class="form-group col-md-5 d-flex align-items-end">
        <button class="btn btn-t01 btn-white p-2 me-n1 w-100" (click)="modal.dismiss('Cancel')">Cancel</button>
      </div>
      <div class="form-group col-md-5 d-flex align-items-end">
        <button class="btn-t01 btn-navy p-2 me-n1 w-100" (click)="modal.close('Register')">
          @if (isLoading) {
            <span class="spinner-border spinner-border-sm me-1"></span>
          }
          Proceed
        </button>
      </div>
    </div>
  </div>
</ng-template>


<!-- ══════════════════════════════════════
MODAL — Help : How to Login
══════════════════════════════════════ -->
<ng-template #helpPopup let-modal>
  <div class="help-modal">

    <!-- Header -->
    <div class="help-header">
      <div class="help-header-text">
        <span class="help-header-icon"><i class="pi pi-question-circle"></i></span>
        <div>
          <h2>How to Login</h2>
          <p>Follow these simple steps to sign in to the FleetCare</p>
        </div>
      </div>
      <button type="button" class="help-close" aria-label="Close" (click)="modal.dismiss('Close')">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Tabs -->
    <div class="help-tabs" role="tablist">
      <button type="button" role="tab" class="help-tab" [class.active]="helpTab === 'first'"
        [attr.aria-selected]="helpTab === 'first'" (click)="helpTab = 'first'">
        <i class="pi pi-user-plus me-1"></i> First-time login
      </button>
      <button type="button" role="tab" class="help-tab" [class.active]="helpTab === 'returning'"
        [attr.aria-selected]="helpTab === 'returning'" (click)="helpTab = 'returning'">
        <i class="pi pi-sign-in me-1"></i> Already registered
      </button>
    </div>

    <!-- Body -->
    <div class="help-body">

      @if (helpTab === 'first') {
        <p class="help-intro">
          First time here? You need a one-time setup of <strong>Two-Factor Authentication</strong>
          on your mobile phone. It takes about 2 minutes.
        </p>
      } @else {
        <p class="help-intro">
          Your authenticator app is already set up. Just follow these quick steps every time you log in.
        </p>
      }

      <ol class="help-steps">

        <!-- Step: CRM login -->
        <li class="help-step">
          <span class="help-step-badge">1</span>
          <div class="help-step-content">
            <h3><i class="pi pi-user me-2"></i>Enter your CRM Username &amp; Password</h3>
            <p>Use the same <strong>Siebel CRM</strong> User ID and Password that you use for CRM.</p>
            <div class="help-note help-note-info">
              <i class="pi pi-info-circle"></i>
              <span>Your username can contain only letters, numbers, dot ( . ), underscore ( _ ) and hyphen ( - ).</span>
            </div>
          </div>
        </li>

        <!-- Step: CAPTCHA -->
        <li class="help-step">
          <span class="help-step-badge">2</span>
          <div class="help-step-content">
            <h3><i class="pi pi-shield me-2"></i>Type the Captcha exactly as shown</h3>
            <p>Type the 6 characters shown in the grey box. Then click <strong>Login</strong>.</p>
            <div class="help-captcha-demo">
              <span class="captcha-box">K7PXM4</span>
              <i class="pi pi-arrow-right"></i>
              <span class="help-demo-input">K7PXM4</span>
              <i class="pi pi-check-circle help-ok"></i>
            </div>
            <div class="help-note help-note-warn">
              <i class="pi pi-exclamation-triangle"></i>
              <span><strong>Captcha is case-sensitive.</strong> Capital letters (A–Z) must be typed as capital
                letters. Turn <strong>Caps Lock ON</strong> if needed.</span>
            </div>
            <p class="help-small">Cannot read it? Click the <i class="pi pi-refresh"></i> refresh icon to get a new captcha.</p>
          </div>
        </li>

        @if (helpTab === 'first') {

          <!-- Step: Install app -->
          <li class="help-step">
            <span class="help-step-badge">3</span>
            <div class="help-step-content">
              <h3><i class="pi pi-download me-2"></i>Install an Authenticator app on your phone</h3>
              <p>Download <strong>one</strong> of these free apps from the Play Store (Android) or App Store (iPhone).</p>
              <div class="help-apps">
                <div class="help-app-card">
                  <div class="help-app-name"><i class="pi pi-microsoft"></i> Microsoft Authenticator</div>
                  <div class="help-app-links">
                    <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank"
                      rel="noopener noreferrer"><i class="pi pi-android"></i> Android</a>
                    <a href="https://apps.apple.com/app/microsoft-authenticator/id983156458" target="_blank"
                      rel="noopener noreferrer"><i class="pi pi-apple"></i> iPhone</a>
                  </div>
                </div>
                <div class="help-app-card">
                  <div class="help-app-name"><i class="pi pi-google"></i> Google Authenticator</div>
                  <div class="help-app-links">
                    <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                      target="_blank" rel="noopener noreferrer"><i class="pi pi-android"></i> Android</a>
                    <a href="https://apps.apple.com/app/google-authenticator/id388497605" target="_blank"
                      rel="noopener noreferrer"><i class="pi pi-apple"></i> iPhone</a>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <!-- Step: Scan QR -->
          <li class="help-step">
            <span class="help-step-badge">4</span>
            <div class="help-step-content">
              <h3><i class="pi pi-qrcode me-2"></i>Scan the QR code</h3>
              <p>After a successful login, a <strong>QR code</strong> is shown on this page.</p>
              <ul class="help-list">
                <li>Open the authenticator app and tap <strong>+ (Add account)</strong>.</li>
                <li>Choose <strong>Scan a QR code</strong> and point your camera at the QR code on the screen.</li>
                <li>Cannot scan? Click <strong>Show code</strong> on the page and type the key into the app manually.</li>
              </ul>
            </div>
          </li>

          <!-- Step: Enter OTP -->
          <li class="help-step">
            <span class="help-step-badge">5</span>
            <div class="help-step-content">
              <h3><i class="pi pi-mobile me-2"></i>Enter the 6-digit code &amp; click Verify</h3>
              <p>Your app now shows a <strong>6-digit code</strong>. Type it in the box on the page and click
                <strong>Verify</strong>. You are logged in!</p>
              <div class="help-note help-note-info">
                <i class="pi pi-clock"></i>
                <span>The code changes every <strong>30 seconds</strong>. If it expires, simply type the new one.</span>
              </div>
            </div>
          </li>

        } @else {

          <!-- Step: Enter OTP (returning) -->
          <li class="help-step">
            <span class="help-step-badge">3</span>
            <div class="help-step-content">
              <h3><i class="pi pi-mobile me-2"></i>Open your Authenticator app</h3>
              <p>Open <strong>Microsoft</strong> or <strong>Google Authenticator</strong> on your phone and find the
                6-digit code for the FleetCare account.</p>
            </div>
          </li>
          <li class="help-step">
            <span class="help-step-badge">4</span>
            <div class="help-step-content">
              <h3><i class="pi pi-key me-2"></i>Enter the code &amp; click Verify Code</h3>
              <p>Type the 6-digit code on the Two-Factor Authentication screen and click <strong>Verify Code</strong>.</p>
              <div class="help-note help-note-info">
                <i class="pi pi-clock"></i>
                <span>The code changes every <strong>30 seconds</strong>. If it expires, simply type the new one.</span>
              </div>
            </div>
          </li>

        }
      </ol>

      <!-- Troubleshooting -->
      <div class="help-trouble">
        <h4><i class="pi pi-wrench me-2"></i>Having trouble?</h4>
        <ul class="help-list">
          <li><strong>Captcha incorrect?</strong> Check Caps Lock and type capital letters exactly as shown.</li>
          <li><strong>Code not accepted?</strong> Wait for the next code and try again. Make sure your phone's date &amp;
            time is set to <strong>Automatic</strong>.</li>
          <li><strong>Login failed?</strong> Check that your CRM username and password are correct.</li>
          <li><strong>Already logged in on 5 - another device?</strong> Choose <strong>Force Login</strong> to continue here.</li>
          <li><strong>Lost or changed your phone?</strong> Contact your administrator / support team to reset your authenticator.</li>
          <li>
            <strong>Dealers should report incidents through the following channels:</strong>
            <ul class="help-list">
              <li>
                <strong>IT Service Desk Portal:</strong>
                <a href="https://itservicedesk.tatamotors.com" target="_blank" rel="noopener noreferrer">
                  https://itservicedesk.tatamotors.com
                </a>
                <div><strong>Category:</strong> WEB CV-VAS, <strong>Assignment Group:</strong> RunOps Mobility-CV_VAS</div>
              </li>
              <li>
                <strong>Email:</strong>
                <a href="mailto:crmdms@tatamotors.com">crmdms@tatamotors.com</a>;
                <a href="mailto:FleetCareSupport@tatamotors.com">FleetCareSupport@tatamotors.com</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!-- Footer -->
    <div class="help-footer">
      <button type="button" class="btn-t01 btn-navy help-done" (click)="modal.close('Done')">Got it</button>
    </div>
  </div>
</ng-template>